//Npm
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';

// Bootstrap CSS
import 'bootstrap/dist/css/bootstrap.css';

// Components
import store from './store';
import App from 'Components/App';

ReactDOM.render(
  <Provider store={store}>
    <App />
  </Provider>,
  document.getElementById('root')
);



// WEBPACK FOOTER //
// ./src/index.js